import {h} from 'ui/Framework';

export default h('svg', {
  width: '9',
  height: '24',
  viewBox: '-1 -1 11 26',
  xmlns: 'http://www.w3.org/2000/svg'
}, [
  h('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, [
    h('g', {
      fill: '#2D2F31'
    }, [
      h('g', [
        h('path', {
          d: 'M7.071 21.403l-.22.938c-.898.361-1.616.613-2.153.754-.537.142-.996.213-1.377.213-.781 0-1.367-.203-1.758-.608-.39-.406-.585-.906-.585-1.502 0-.224.02-.459.058-.703.04-.244.103-.552.19-.923l1.553-6.225c.078-.342.154-.708.227-1.099.074-.39.11-.723.11-.996 0-.547-.09-.91-.27-1.091-.181-.181-.55-.271-1.107-.271-.215 0-.5.034-.857.102-.356.069-.627.127-.813.176l.22-.938a14.4 14.4 0 0 1 2.05-.761c.606-.166 1.085-.25 1.436-.25.801 0 1.382.191 1.744.572.36.38.542.894.542 1.538 0 .176-.02.415-.059.718-.04.303-.098.605-.176.908L4.26 18.181c-.098.38-.183.754-.257 1.12-.073.366-.11.667-.11.901 0 .557.125.938.374 1.143.25.205.652.307 1.209.307.185 0 .451-.024.798-.073.347-.049.613-.107.798-.176zm1.04-18.72A2.15 2.15 0 0 1 7.57 4.14c-.361.415-.81.623-1.347.623-.498 0-.928-.198-1.29-.594-.36-.395-.541-.847-.541-1.355 0-.537.18-1.005.542-1.406.36-.4.79-.6 1.289-.6.556 0 1.01.188 1.362.564.352.376.527.813.527 1.31z'
        })
      ])
    ])
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/fd-info-text.es6.js